import React from 'react';
import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
import styles from './memoriamarato.module.scss';
import type { LinksData, MemoriaGroup, MemoriaMaratoProps } from './MemoriaMarato.types';

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    title?: string;
    novaFinestra?: boolean;
    children: React.ReactNode;
}>;

const ABERTIS_IMG = 'https://statics.3cat.cat/recursos/marato/img/abertis-logo.jpg';

const LEGACY_MEMORIES: Record<string, LinksData> = {
    '2014': {
        subtitle: 'La Marató 2014: Malalties del cor',
        abertis: true,
        groups: [
            {
                title: 'La Marató 2014: Malalties del cor',
                sections: [
                    {
                        heading: 'Programa',
                        links: [
                            {
                                href: '/tv3/alacarta/la-marato-2014-hora-a-hora/coleccio/7690/',
                                text: 'Les 15 hores en directe'
                            },
                            {
                                href: '/tv3/marato/que-es/2014/113/',
                                text: 'Les malalties del cor'
                            },
                            {
                                href: '/tv3/marato/videos/2014/50/',
                                text: 'Vídeos del programa'
                            },
                            {
                                href: '/tv3/marato/que-es/2014/113/',
                                text: 'Associacions de malalts'
                            }
                        ]
                    },
                    {
                        heading: 'Participació ciutadana i empresarial',
                        links: [
                            {
                                href: '/tv3/marato/activitats-populars/2014/151/',
                                text: 'Activitats populars'
                            },
                            {
                                href: '/tv3/marato/seus-telefoniques/2014/373/',
                                text: 'Seus telefòniques'
                            },
                            {
                                href: '/tv3/marato/empreses-solidaries/2014/190/',
                                text: 'Participació empresarial'
                            },
                            {
                                href: '/tv3/marato/fundacio/memoria-2014/participacio/',
                                text: 'Voluntaris'
                            },
                            {
                                href: '/tv3/marato/fundacio/memoria-2014/participacio/',
                                text: 'Altres formes de suport'
                            }
                        ]
                    },
                    {
                        heading: 'Sensibilització i difusió',
                        links: [
                            {
                                href: '/tv3/marato/la-campanya/2014/114/',
                                text: 'Campanya gràfica i audiovisual'
                            },
                            {
                                href: '/tv3/marato/conferencies-educatives/2014/170/',
                                text: 'Sensibilització a les escoles i 16è concurs Pinta La Marató'
                            },
                            {
                                href: '/tv3/marato/disc/2014/378/',
                                text: 'El disc de La Marató'
                            },
                            {
                                href: '/tv3/marato/el-llibre/2014/191/',
                                text: 'El llibre de La Marató'
                            },
                            {
                                href: '/tv3/marato/fundacio/memoria-2014/comunicacio/',
                                text: 'Comunicació'
                            }
                        ]
                    },
                    {
                        heading: 'Les xifres de La Marató 2014',
                        links: [
                            {
                                href: '/tv3/marato/xifres/2014/110/',
                                text: 'Les xifres de La Marató 2014'
                            }
                        ]
                    }
                ]
            },
            {
                title: 'Recerca biomèdica',
                sections: [
                    {
                        heading: 'Impuls a la recerca en malalties neurodegeneratives. La Marató 2013',
                        links: [
                            {
                                href: '/tv3/marato/fundacio/memoria-2014/recerca-en-malalties-neurodegeneratives/',
                                text: 'Impuls a la recerca en malalties neurodegeneratives. La Marató 2013'
                            }
                        ]
                    },
                    {
                        heading: '15è Simpòsium. Resultats de La Marató 2008: malalties mentals greus',
                        links: [
                            {
                                href: '/tv3/marato/fundacio/memoria-2014/simposium-malalties-mentals-greus/',
                                text: '15è Simpòsium. Resultats de La Marató 2008: malalties mentals greus'
                            }
                        ]
                    }
                ]
            },
            {
                title: 'Altres',
                sections: [
                    {
                        heading: 'Reconeixements',
                        links: [
                            {
                                href: '/tv3/marato/fundacio/memoria-2014/reconeixements/',
                                text: 'Premis rebuts durant el 2015'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    '2015': {
        subtitle: 'La Marató 2015: Diabetis i obesitat',
        abertis: true,
        groups: [
            {
                title: 'La Marató 2015: Diabetis i obesitat',
                sections: [
                    {
                        heading: 'Programa',
                        links: [
                            {
                                href: '/tv3/alacarta/la-marato-2015-hora-a-hora/coleccio/7691/',
                                text: 'Les 18 hores en directe'
                            },
                            {
                                href: '/tv3/marato/que-es/2015/10/',
                                text: 'Diabetis i obesitat'
                            },
                            {
                                href: '/tv3/marato/videos/2015/10/',
                                text: 'Vídeos del programa'
                            },
                            {
                                href: '/tv3/marato/que-es/2015/10/',
                                text: 'Associacions de malalts'
                            }
                        ]
                    },
                    {
                        heading: 'Participació ciutadana i empresarial',
                        links: [
                            {
                                href: '/tv3/marato/activitats-populars/2015/34/',
                                text: 'Activitats populars'
                            },
                            {
                                href: '/tv3/marato/seus-telefoniques/2015/370/',
                                text: 'Seus telefòniques'
                            },
                            {
                                href: '/tv3/marato/empreses-solidaries/2015/39/',
                                text: 'Participació empresarial'
                            },
                            {
                                href: '/tv3/marato/fundacio/memoria-2015/participacio/',
                                text: 'Voluntaris'
                            },
                            {
                                href: '/tv3/marato/fundacio/memoria-2015/participacio/',
                                text: 'Altres formes de suport'
                            }
                        ]
                    },
                    {
                        heading: 'Sensibilització i difusió',
                        links: [
                            {
                                href: '/tv3/marato/la-campanya/2015/32/',
                                text: 'Campanya gràfica i audiovisual'
                            },
                            {
                                href: '/tv3/marato/conferencies-educatives/2015/35/',
                                text: 'Sensibilització a les escoles i 17è concurs Pinta La Marató'
                            },
                            {
                                href: '/tv3/marato/disc/2015/294/',
                                text: 'El disc de La Marató'
                            },
                            {
                                href: '/tv3/marato/llibre/2015/41/',
                                text: 'El llibre de La Marató'
                            },
                            {
                                href: '/tv3/marato/fundacio/memoria-2015/comunicacio/',
                                text: 'Comunicació'
                            }
                        ]
                    },
                    {
                        heading: 'Les xifres de La Marató 2015',
                        links: [
                            {
                                href: '/tv3/marato/xifres/2015/350/',
                                text: 'Les xifres de La Marató 2015'
                            }
                        ]
                    }
                ]
            },
            {
                title: 'Recerca biomèdica',
                sections: [
                    {
                        heading: 'Impuls a la recerca',
                        links: [
                            {
                                href: '/tv3/marato/fundacio/memoria-2015/recerca-en-malalties-del-cor/',
                                text: 'Malalties del cor. La Marató 2014'
                            }
                        ]
                    },
                    {
                        heading: '16è Simpòsium',
                        links: [
                            {
                                href: '/tv3/marato/fundacio/memoria-2015/simposium-malalties-minoritaries/',
                                text: 'Resultats de la recerca de La Marató 2009: malalties minoritàries'
                            }
                        ]
                    }
                ]
            },
            {
                title: 'Altres',
                sections: [
                    {
                        heading: 'Convocatòria de propostes de malalties',
                        links: [
                            {
                                href: '/tv3/marato/recerca/proposta-malalties/',
                                text: 'Convocatòria de propostes de malalties'
                            }
                        ]
                    },
                    {
                        heading: 'Exposició fotogràfica',
                        links: [
                            {
                                href: '/tv3/marato/exposicio-fotografica/2015/390/',
                                text: 'Una mirada als valors de La Marató'
                            }
                        ]
                    },
                    {
                        heading: 'Visita la recerca de La Marató',
                        links: [
                            {
                                href: '/tv3/marato/fundacio/memoria-2015/projecte-pilot/',
                                text: 'Projecte pilot'
                            }
                        ]
                    },
                    {
                        heading: 'Reconeixements',
                        links: [
                            {
                                href: '/tv3/marato/fundacio/memoria-2015/reconeixements/',
                                text: 'Premis rebuts durant el 2015'
                            }
                        ]
                    }
                ]
            }
        ]
    }
};

function MemoriaGroupItem({ group }: { group: MemoriaGroup }) {
    return (
        <div className={styles.group}>
            <h2 className={styles.groupTitle}>{group.title}</h2>
            {group.sections.map((section) => (
                <div key={section.heading} className={styles.section}>
                    <h3 className={styles.sectionHeading}>{section.heading}</h3>
                    <ul className={styles.linkList}>
                        {section.links.map((link) => (
                            <li key={link.href}>
                                <Enllac href={link.href} title={link.text}>
                                    {link.text}
                                </Enllac>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}

export default function MemoriaMaratoEstatic({ anyMarato }: MemoriaMaratoProps) {
    const data = LEGACY_MEMORIES[anyMarato];

    if (!data) return null;

    return (
        <div className={styles.wrapper}>
            {data.groups.map((group) => (
                <MemoriaGroupItem key={group.title} group={group} />
            ))}
            {data.abertis && (
                <aside className={styles.suport}>
                    <p>
                        <small>
                            <strong>Amb el suport de:</strong>
                        </small>
                    </p>
                    <Enllac href='https://www.fundacioabertis.org/' title='Fundació Abertis' novaFinestra={true}>
                        <Imatge src={ABERTIS_IMG} alt='Fundació Abertis' width={130} height={50} />
                    </Enllac>
                </aside>
            )}
        </div>
    );
}
